import { useDispatch } from 'react-redux'

import { homeGetStarted } from 'routes/Home/homeActions'

export const useGetHowGoustoWorksData = () => {
  const dispatch = useDispatch()

  return {
    trackClickGetStartedCTA: (ctaUri: string, sectionForTracking: string) =>
      dispatch(homeGetStarted(ctaUri, sectionForTracking)),
  }
}
